import type { CensusLine } from '@features/insurances/models/census-line.model';

const BASE: CensusLine = {
  censusLineId: 'cl-001',
  censusLineNumber: '001',
  coverArea: 'Slovakia',
  externalId: null,
  hasIpIdDocument: true,
  hasSobDocument: true,
  hasTcDocument: true,
  insuranceJoined: '2025-01-01',
  insuranceLeft: '2026-12-31',
  insuranceType: 'Health Insurance',
  insuredName: 'John Doe',
  insuredPersonId: 'person-123',
  memberId: 'MEM-001',
  membershipLink: null,
  planId: 'plan-1',
  planName: 'Premium Health Plan',
  policyHolder: 'John Doe',
  policyId: 'policy-1',
  policyNumber: 'P-001',
  principalPersonId: 'person-123',
  principalPersonName: 'John Doe',
  role: 'Insured',
  status: 'Active',
  telemedicineEnabled: true
};

export const CENSUS_LINE_SCENARIOS = {
  /** TC-3.1: Claims instructions present (Cambodia example from task) — collapsed accordion with callable phones */
  TC_3_1: {
    ...BASE,
    claimsInstructions:
      'FOR REIMBURSEMENT OF MEDICAL EXPENSES INCURRED IN ANY COUNTRY, AND A GENERAL ADVICE:\n\n' +
      'Alpha Insurance Broker\n\n' +
      '(ONLY AT WORKING HOURS FROM 8.30AM TO 5PM MONDAY TO FRIDAY CAMBODIAN TIME)  ' +
      '+855.96.555.62.41  claims@alphainb.com\n\n' +
      'NON-URGENT HOSPITALISATION IN THE KINGDOM OF CAMBODIA,\n\n' +
      'CASES OF TREATMENT IN THE KINGDOM OF CAMBODIA REQUIRING PREAUTHORISATION ' +
      '(5 WORKING DAYS ADVANCE NOTIFICATION REQUIRED)\n\n' +
      'Alpha Insurance Broker   (ONLY AT WORKING HOURS FROM 8.30AM TO 5PM MONDAY TO FRIDAY CAMBODIAN TIME)  ' +
      '+855.92.555.980 (981/982)  claims@alphainb.com\n\n' +
      'IN CASE OF NON-URGENT HOSPITALISATION OR PRE-AUTHORIZATION REQUEST OUTSIDE THE KINGDOM OF CAMBODIA, ' +
      'EMERGENCY MEDICAL EVACUATION, EXPENSIVE OUTPATIENT MEDICAL MANIPULATION OUTSIDE THE KINGDOM OF CAMBODIA, ' +
      'REQUIRING PREAUTHORISATION (5 WORKING DAYS ADVANCE NOTIFICATION REQUIRED)\n\n' +
      'English & French speaking service 24/7  +1.888.555.1404  claims@dhig.net'
  } satisfies CensusLine,

  /** TC-3.2: Short claims instructions with single phone */
  TC_3_2: {
    ...BASE,
    claimsInstructions:
      'Please contact the claims department at claims@example.com or call +421 2 1234 5678.'
  } satisfies CensusLine,

  /** TC-3.3: Online submission with URL + physical address — no phone numbers */
  TC_3_3: {
    ...BASE,
    claimsInstructions:
      'All Claims must be submitted through https://sign.dhig.net/claim/ or send to: claims@dhig.net\n' +
      'If the Coverholder requests presenting originals of medical documentation, ' +
      'then they must be sent at the following address: Am Heumarkt 10/1, 1030, Vienna, Austria'
  } satisfies CensusLine,

  /** TC-3.4: Bulgaria local/international routing — WTW France with 00-prefix hotline */
  TC_3_4: {
    ...BASE,
    coverArea: 'Bulgaria',
    claimsInstructions:
      'Local claims in Bulgaria are handled by the insurer, outside of Bulgaria by Assistance company or dhig\n\n' +
      'Physical address: WTW International Services (WTWIS)\n' +
      'Tour HEKLA, 52 Avenue du Général de Gaulle, 92800 Puteaux\n' +
      '24/7 hotline: 00.33.1.55.55.61.61\n' +
      'Address to send claims (for digitisation):\n' +
      'GSIS     TSA 24 331     77283 Avon CEDEX      France'
  } satisfies CensusLine,

  /** TC-4.1: claimsInstructions undefined — section NOT shown */
  TC_4_1: {
    ...BASE
  } satisfies CensusLine,

  /** TC-4.2: claimsInstructions empty string — section NOT shown */
  TC_4_2: {
    ...BASE,
    claimsInstructions: ''
  } satisfies CensusLine
} satisfies Record<string, CensusLine>;
